(function () {
  const menuBtn = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-nav]");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", String(open));
    });
    nav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        nav.classList.remove("is-open");
        menuBtn.setAttribute("aria-expanded", "false");
      });
    });
  }

  document.querySelectorAll("[data-gallery-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const src = btn.getAttribute("data-src");
      const main = document.querySelector("[data-gallery-main]");
      if (src && main) {
        main.src = src;
        document.querySelectorAll("[data-gallery-thumb]").forEach((b) => b.removeAttribute("aria-current"));
        btn.setAttribute("aria-current", "true");
      }
    });
  });

  const idInput = document.querySelector("[data-variant-id]");
  document.querySelectorAll("[data-variant-option]").forEach((input) => {
    input.addEventListener("change", () => {
      if (idInput && input.checked) {
        idInput.value = input.value;
        const price = input.getAttribute("data-price");
        const priceEl = document.querySelector("[data-product-price]");
        if (price && priceEl) priceEl.innerHTML = price;
      }
    });
  });
})();
